import {
  GENERIC_ERROR_MESSAGE_FALLBACK,
  GENERIC_ERROR_STATUS,
  GENERIC_ERROR_TRANSLATION_KEY,
} from '@shared/utils/constants/errors';

import { getPublicEnvironmentVariables } from '../helpers/get-public-environment-variables';
import { invalidateProfilePhotoTag } from '../helpers/invalidate-profile-photo-tag';
import { type MutationError } from '../types/mutation-error';

export const postProfilePicture = async ({
  abortSignal,
  accessToken,
  formData,
  personId,
}: {
  abortSignal: AbortSignal;
  accessToken: string | undefined;
  formData: BodyInit;
  personId: number | string | undefined;
}): Promise<MutationError | null | Response> => {
  const publicEnvironmentVariables = await getPublicEnvironmentVariables();

  try {
    const response = await fetch(
      `${publicEnvironmentVariables.apiBaseUrl}/${publicEnvironmentVariables.apiRoute}/CustomerProfile/${personId}/ProfilePicture`,
      {
        body: formData,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Ocp-Apim-Subscription-Key': publicEnvironmentVariables.ocpApiSubscriptionKey ?? '',
        },
        method: 'POST',
        signal: abortSignal,
      }
    );

    if (response.status !== 200) {
      const resolvedResponse = await response.json();

      return {
        message: resolvedResponse.message || response.statusText,
        messageTranslationKey: resolvedResponse.messageTranslationKey || '',
        status: response.status,
      };
    }

    await invalidateProfilePhotoTag(personId);

    return response;
  } catch {
    if (abortSignal.aborted) {
      return null;
    }

    return {
      message: GENERIC_ERROR_MESSAGE_FALLBACK,
      messageTranslationKey: GENERIC_ERROR_TRANSLATION_KEY,
      status: GENERIC_ERROR_STATUS,
    };
  }
};
